import { validatePhoneNumber } from '@/lib/validation/phoneValidation';
import { z } from 'zod';

// Walk-in / manual PAID order: admin enters the customer by hand plus the
// ordering doctor and clinic. `doctor_id`/`clinic_id` are Combobox string ids.
export const createWalkInOrderSchema = z.object({
  name: z.string().min(1, 'Cart name is required'),
  customer_firstname: z.string().min(1, 'First name is required'),
  customer_lastname: z.string().min(1, 'Last name is required'),
  phone: z
    .string()
    .min(1, 'Phone number is required')
    .refine((value) => validatePhoneNumber(value), 'Invalid phone number'),
  doctor_id: z.string().min(1, 'Doctor is required'),
  clinic_id: z.string().min(1, 'Clinic is required'),
});

export type CreateWalkInOrderFormValues = z.infer<
  typeof createWalkInOrderSchema
>;
